<template>
    <el-dialog
        :title="title"
        :visible.sync="dialogVisible"
        width="1000px" :close-on-click-modal="false">
        <div class="dialogContent" v-loading="loading">
            <el-form :model="form" ref="ruleForm" label-width="120px">
                <!-- <el-form-item label="姓名" prop="uuid">
                    <div class="inputMess">
                        <el-input placeholder="请输入内容" v-model="input3" class="input-with-select">
                            <el-select filterable clearable v-model="form.uuid" placeholder="姓名" slot="prepend" @change="getUserInfo">
                                <el-option
                                    v-for="(item,index) in userInfo"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.uuid">
                                </el-option>
                            </el-select>
                        </el-input>
                    </div>
                </el-form-item> -->
                <el-form-item label="姓名" prop="uuid">
                    <el-select filterable clearable  v-model="form.uuid" placeholder="姓名" @change="getUserInfo">
                        <el-option
                            v-for="(item,index) in userInfo"
                            :key="index"
                            :label="`${item.name}(${item.tel})`"
                            :value="item.uuid">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="用户昵称" prop="activityName">
                    <el-input v-model="form.activityName" disabled placeholder="用户昵称"></el-input>
                </el-form-item>
                <el-form-item label="性别" prop="gender">
                    <el-select v-model="form.gender" disabled placeholder="性别" style="width: 100%;">
                        <el-option label="男" value="MALE"> </el-option>
                        <el-option label="女" value="FEMALE"> </el-option>
                        <el-option label="秘密" value="NONE"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系电话" prop="telephone">
                    <el-input v-model="form.telephone" disabled placeholder="联系电话"></el-input>
                </el-form-item>
                <!--<el-form-item label="作品类型" prop="activityType" v-if="worksType">
                    <el-select v-model="form.activityType" placeholder="作品类型" style="width: 100%;">
                        <el-option label="分类1" value="1"> </el-option>
                        <el-option label="分类2" value="2"> </el-option>
                        <el-option label="分类3" value="3"> </el-option>
                    </el-select>
                </el-form-item>-->
                <el-form-item class="submitButtonClass">
                    <el-button type="primary" @click="submit">提交</el-button>
                </el-form-item>
            </el-form>
        </div>
    </el-dialog>
</template>

<script>
    import { getActivityUserInfo, saveJudge, getJudgeLibraryDetail } from '../../utils/interface';
    export default {
        name: "materialManagementDialog",
        data() {
            return {
                userInfo:[],
                dialogVisible: false,
                loading: false,
                id: '',
                title: '',
                form: {
                    uuid:'',
                    activityName: '',
                    userName: '',
                    telephone: '',
                    activityType: '',
                    gender: '',
                    input3: '',
                },
                worksType: true,
                item: '',
            }
        },
        methods: {
            getUserInfo(){
                this.userInfo.map((item)=>{
                    if(item.uuid==this.form.uuid){
                        this.form.activityName = item.name;
                        this.form.telephone = item.tel;
                        this.form.gender = item.gender;
                    }
                });
                // 判断用户是否已经保存过(不启用的也算)
                getJudgeLibraryDetail({userUuid:this.form.uuid,type:this.item}).then((res)=>{
                    if(res.data!=null){
                        let libraryName = this.item==='JUDGE'?'评委库':'领导库';
                        let survival = res.data.survival=='ENABLE'?'启用':'停用';
                        this.$message.error("该账号目前已被添加至"+libraryName+",无法再次进行添加!");
                        this.form.activityName = '';
                        this.form.telephone = '';
                        this.form.gender = '';
                        this.form.uuid = '';
                        this.form.input3 = '';
                    }
                });
            },
            init(type,item) {
                this.form.activityName = '';
                this.form.telephone = '';
                this.form.gender = '';
                this.form.uuid = '';
                this.form.input3 = '';
                this.item = item;
                this.dialogVisible = true;
                if (type === 'add') {
                    this.title = '新增'
                } else if (type === 'addLeader'){
                    this.worksType = false;
                    this.title = '新增'
                } else if (type === 'modify'){
                    this.title = '修改';
                    this.worksType = false
                }
                getActivityUserInfo().then((res)=>{
                    if(res.success) {
                        this.userInfo = res.data;
                    }
                });
            },
            submit(){
                let params = {
                    userUuid:this.form.uuid,
                    type:this.item,
                    survival:"ENABLE"
                };
                this.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        saveJudge(params).then((res)=>{
                            if(res.success){
                                this.$message.success("保存成功");
                                this.dialogVisible = false;
                                this.$emit('submit');
                            }
                        });
                    }
                });
            },
            // 验证电话号码
            validatorPhone(rule, value, callback) {
                if (value === '') {
                    callback(new Error('请输入收票人电话'))
                } else if (!/^1\d{10}$/.test(value)) {
                    callback(new Error('请输入正确的电话号码'))
                } else {
                    callback()
                }
            },
        }
    }
</script>

<style scoped lang="less">
    .dialogContent {
        padding: 0 5%;
        /deep/.el-upload-list--picture-card .el-upload-list__item{
            width: 590px;
            height: 300px;
        }
        /deep/.el-upload--picture-card{
            width: 590px;
            height: 300px;
            line-height: 300px;
        }
        /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail{
            width: 590px;
            height: 300px;
        }
        .thumbnailClass{
            width: 590px;
            height: 300px;
            .avatar{
                width: 590px;
                height: 300px;
                border: 1px dashed #ddd;
                border-radius: 4px;
                line-height: 300px;
                font-size: 50px;
            }
        }
        .endPeriodClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
        .submitButtonClass{
            /deep/.el-form-item__content{
                margin-left: 0 !important;
                text-align: center;
                button{
                    padding: 0;
                    width: 120px;
                    height: 35px;
                    line-height: 35px;
                    border-radius: 6px;
                }
            }
        }
        .modelHeightRangeClass{
            display: flex;
            margin-bottom: 25px;
            /deep/.el-form-item__content{
                margin-left: 0 !important;
            }
        }
    }
.inputMess {
  /deep/.el-input-group__prepend {
    width: 130px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/managementDialog.vue